/**
 * '#7F80FA' is a lighter / accessible version of Klein Blue meant for dark
 * backgrounds.
 *
 * Follow along at https://ghe.spotify.net/encore/foundation/issues/29 for
 * discussions on accessible dark themed color tokens.
 */
export const darkModeKleinBlue = '#7F80FA';
